import { useRoutes } from "react-router-dom";

// routes
import MainRoutes from "../config/routes";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([MainRoutes]);
}
